"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoodNotification = void 0;
const currency_label_1 = require("@components/currency-label");
const translation_hooks_1 = require("@hooks/translation.hooks");
const react_1 = __importStar(require("react"));
require("./styles.scss");
const GoodNotification = (props) => {
    const { remove, removeAfterMs, popKey, title, price, tokenAddress, previewSrc, isAdding } = props;
    const translator = (0, translation_hooks_1.useComponentTranslation)("notifications.goodNotification");
    (0, react_1.useEffect)(() => {
        setTimeout(() => remove(popKey), removeAfterMs);
    }, []);
    return (react_1.default.createElement("div", { className: "c-good-notification" },
        react_1.default.createElement("div", { className: "c-good-notification__title" }, translator(isAdding ? "addedNftToCartLabel" : "removedNftFromCartLabel")),
        react_1.default.createElement("div", { className: "c-good-notification__nft" },
            react_1.default.createElement("img", { className: "c-good-notification__nft-preview", src: previewSrc }),
            react_1.default.createElement("div", { className: "c-good-notification__nft-content" },
                react_1.default.createElement("div", { className: "c-good-notification__nft-title" }, title),
                react_1.default.createElement(currency_label_1.CurrencyLabel, { tokenAddress: tokenAddress, amount: price })))));
};
exports.GoodNotification = GoodNotification;
